import {createSlice} from "@reduxjs/toolkit";
import {DATA_LIMIT} from "../../app/constants";

const recurringVoucher = createSlice({
	name: "recurringVoucher",
	initialState: {
		loading: false,
		error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT
		},
		items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const recurringVoucherActions = recurringVoucher.actions;
//Reducers
export const recurringVoucherReducer = recurringVoucher.reducer;
//Selectors
export const recurringVoucherItemsSelector = (state) => state.recurringVoucher.items;
export const recurringVoucherLoadingSelector = (state) => state.recurringVoucher.loading;
export const recurringVoucherErrorSelector = (state) => state.recurringVoucher.error;
export const recurringVoucherFilterSelector = (state) => state.recurringVoucher.filter;
export const recurringVoucherPaginationSelector = (state) => state.recurringVoucher.pagination;
